import { CallToAction, LinkButton } from './styles'
import { animationVariantsRight } from 'src/theme/animations/swipeIn'
import Button from 'src/components/common/Button'
import React from 'react'
import { useTranslations } from 'src/provider/LocaleProvider'
import { ROUTES } from 'src/navigation'

export function CallToActionComponent() {
    const t = useTranslations()

    return (
        <CallToAction
            marginLeft={['medium', 'xmedium', 0, 'xspacesFull']}
            animate="animate"
            variants={animationVariantsRight}
        >
            <LinkButton to={ROUTES.BOOK_A_CALL}>
                <Button Content={t('cta.bookACall')} />
            </LinkButton>
        </CallToAction>
    )
}
